var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',[_c('keep-alive',[_c('v-card',{staticClass:"pa-2 ma-1 w-100"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }